import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import LogoFull from "./LogoFull";

export default function AuthLayout({ title, subtitle, children, footer, wide = false }) {
  return (
    <div
      className="relative min-h-screen flex flex-col bg-ink-50"
      data-testid="auth-layout"
    >
      <div className="absolute inset-0 bg-grid opacity-50" aria-hidden="true" />

      <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-6 py-12">
        <div className={wide ? "w-full max-w-3xl" : "w-full max-w-md"}>
          <Link
            to="/"
            data-testid="auth-back-home"
            className="inline-flex items-center gap-2 text-xs uppercase tracking-widest font-semibold text-warm-500 mb-8 hover:text-ink-900 transition-crisp"
          >
            <ArrowLeft size={12} weight="bold" />
            Zurück zur Startseite
          </Link>

          <div className="border border-ink-200 bg-white rounded-sm relative">
            <div className="absolute top-0 left-0 h-1 w-20 bg-brand-400" aria-hidden="true" />
            <div className="px-8 pt-8 pb-2 border-b border-ink-200">
              <div className="mb-6 flex justify-center">
                <LogoFull size="md" />
              </div>
              <h1 className="font-cabinet text-3xl font-medium tracking-tight text-ink-900">
                {title}
              </h1>
              {subtitle && (
                <p className="mt-2 mb-6 text-sm text-warm-600 leading-relaxed">
                  {subtitle}
                </p>
              )}
            </div>
            <div className="px-8 py-6">{children}</div>
          </div>

          {footer && (
            <div className="mt-6 text-center text-sm text-warm-600">{footer}</div>
          )}
        </div>
      </div>
    </div>
  );
}
